export default "__VITE_ASSET__43427b61__"